/* ============================================================
   CS AB TEST — shared behaviour (quick-add dialog, reveals)
   ============================================================ */
(function () {
  /* ---------- Quick-add dialog ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cs-qa-open]');
    if (open) {
      e.preventDefault();
      var scope = open.closest('[data-cs-qa-scope]') || open.closest('.product-tile');
      var dlg = scope && scope.querySelector('dialog[data-cs-qa-dialog]');
      if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
        dlg.showModal();
      }
      return;
    }
    var close = e.target.closest('[data-cs-qa-close]');
    if (close) {
      var d = close.closest('dialog');
      if (d) d.close();
      return;
    }
    var arrow = e.target.closest('[data-cs-qa-prev], [data-cs-qa-next]');
    if (arrow) {
      var track = arrow.closest('[data-cs-qa-gallery]');
      track = track && track.querySelector('[data-cs-qa-track]');
      if (track) {
        var dir = arrow.hasAttribute('data-cs-qa-prev') ? -1 : 1;
        var w = track.clientWidth;
        var max = track.scrollWidth - w;
        var next = track.scrollLeft + dir * w;
        if (next < -1) next = max; /* wrap backwards */
        if (next > max + 1) next = 0; /* wrap forwards */
        /* direct assignment + CSS scroll-behavior:smooth animates in real
           browsers but still scrolls where animations are unavailable */
        track.scrollLeft = next;
      }
      return;
    }
    /* click on the dimmed backdrop closes */
    if (
      e.target instanceof HTMLDialogElement &&
      e.target.hasAttribute('data-cs-qa-dialog')
    ) {
      var r = e.target.getBoundingClientRect();
      if (
        e.clientX < r.left || e.clientX > r.right ||
        e.clientY < r.top || e.clientY > r.bottom
      ) {
        e.target.close();
      }
    }
  });

  /* After add-to-cart submits inside the dialog, close it so the
     theme's cart drawer is visible. */
  document.addEventListener(
    'submit',
    function (e) {
      var dlg = e.target.closest && e.target.closest('dialog[data-cs-qa-dialog]');
      if (dlg) {
        setTimeout(function () {
          try { dlg.close(); } catch (err) { /* noop */ }
        }, 650);
      }
    },
    true
  );

  /* ---------- Scroll reveals (IO with scroll fallback) ---------- */
  function mark(el) { el.classList.add('cs-ab-seen'); }
  function check() {
    document
      .querySelectorAll('[data-cs-reveal]:not(.cs-ab-seen)')
      .forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.88 && r.bottom > 0) mark(el);
      });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            mark(en.target);
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    var observeAll = function () {
      document.querySelectorAll('[data-cs-reveal]').forEach(function (el) {
        io.observe(el);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }
  }
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
  setTimeout(check, 400);
})();
